<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="text-h6">Roles</span>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="openDialog('add')">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="roles"
        item-value="id"
        dense
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Buscar"
            outlined
            dense
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="openDialog('edit', item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <!--v-btn icon color="red" @click="deleterol(item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn-->
        </template>
      </v-data-table>
    </v-card>

    <!-- Diálogo para agregar/editar -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="rol.name"
              label="Nombre"
              outlined
              dense
              required
              :disabled="isEdit"
            ></v-text-field>
          </v-form>
          <v-row v-if="isEdit">
            <v-col cols="12">
              <v-data-table
                :items="itemsPermissions"
                :headers="fieldsPermissions"
                dense
                :loading="overlay"
                class="elevation-1"
                hide-default-footer
              >
                <template v-slot:item.actions="{ item }">
                  <v-checkbox
                    v-model="item.check"
                    label=""
                    hide-details
                  ></v-checkbox>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="saverol">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" :z-index="3000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
    
    <script>
import axios from "@/plugins/axios.js";
export default {
  data() {
    return {
      search: "",
      dialog: false,
      dialogTitle: "",
      headers: [
        { text: "#", value: "id" },
        { text: "Nombre", value: "name" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      roles: [], // Aquí se cargan los datos de ROLES desde la API
      rol: {
        id: null,
        name: "",
        decription: null,
        permissions: [],
      },
      action: "", // 'add' o 'edit'
      overlay: false,
      itemsPermissions: [],
      fieldsPermissions: [
        { text: "#", value: "id" },
        { text: "Nombre", value: "name" },
        { text: "Descripción", value: "description" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      isEdit: false,
      rolePermissions: [],
    };
  },
  mounted() {
    this.getRoles();
  },
  methods: {
    clearForm() {
      this.rol = {
        id: null,
        name: "",
      };
      this.isEdit = false;
    },
    getRoles() {
      this.overlay = true;
      axios
        .get("/admin/getRoles")
        .then((response) => {
          this.roles = [...response.data];
          this.overlay = false;
        })
        .catch((err) => {
          this.overlay = false;
          //this.msjModal = "Error! " + err;
          //this.$refs["msj-modal"].show();
        });
    },
    openDialog(action, rol = null) {
      this.action = action;
      this.isEdit = action === "edit";
      this.dialog = true;
      if (this.isEdit) {
        this.rol = {
          id: rol.id,
          name: rol.name,
          permissions: rol.permissions,
        };
        this.overlay = true;
        axios
          .get("/admin/getPermissions")
          .then((response) => {
            this.itemsPermissions = response.data;
            this.setRolePermissions();
            this.overlay = false;
          })
          .catch((err) => {
            this.overlay = false;
          });
      } else {
        if (!this.isEdit) {
          this.clearForm();
        }
        this.overlay = false;
      }
    },
    setRolePermissions() {
      this.itemsPermissions.map((permission) => {
        const permissionRol = this.rol.permissions.find(
          (permi) => permi.id == permission.id
        );
        if (permissionRol) {
          permission.check = true;
          permission.activeRol = true;
        } else {
          permission.check = false;
          permission.activeRol = false;
        }
        return permission;
      });
    },
    saverol() {
      if (this.isEdit) {
        this.updateRol();
      } else {
        this.createRol();
      }
      this.dialog = false;
    },
    updateRol() {
      this.overlay = true;
      const updatedListPermissions = this.getUpdatedListOfPermissions();
      axios
        .post("/admin/updateRol", {
          id: this.rol.id,
          name: this.rol.name,
          new_list_permissions: updatedListPermissions.newPermissionsList,
          remove_list_permissions: updatedListPermissions.removePermissionsList,
        })
        .then((response) => {
          this.getRoles();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    createRol() {
      this.overlay = true;
      axios
        .post("/admin/createRol", {
          // Aquí debes enviar los datos del formulario
          name: this.rol.name,
        })
        .then((response) => {
          this.getRoles();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    getUpdatedListOfPermissions() {
      const newPermissionsList = [];
      const removePermissionsList = [];

      this.itemsPermissions.forEach((permission) => {
        if (!permission.check && permission.activeRol) {
          removePermissionsList.push(permission.id);
        } else if (permission.check && !permission.activeRol) {
          newPermissionsList.push(permission.id);
        }
      });
      return {
        newPermissionsList: newPermissionsList,
        removePermissionsList: removePermissionsList,
      };
    },
    deleterol(id) {
      // Simulación de eliminación
      this.roles = this.roles.filter((u) => u.id !== id);
    },
  },
};
</script>
    